export default __webpack_public_path__ + "static/media/Sponcerimage17.041442f6.png";